(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('eDocumentsApp')
        .constant('VERSION', "2026.10d-papinet")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1792884873295)
        .constant('LIST_STATE_VERSION', "listState202610d-papinet")
        .constant('RELEASE_YEAR', "2026")
;
})();
